<template>
<div class="popup" v-show="ftpDialog" v-cloak>
    <div id="editFtp" class="content" :class="addFtp" ref="ftpDiv">
        <div class="title">
            <span> {{$t('language.leftBanner.edit')}} FTP</span>
            <div class="icon white-close dialog-close" @click="ftpDialog=false"></div>
        </div>
        <div class="add-ftp-cont">
            <div class="add-cloud-cont-top">
                <div class="add-cloud-drive-position">
                    <div class="cloud FTP  add-cloud-size"></div>
                    <div class="add-cloud-text">
                        <b>FTP</b>
                    </div>
                </div>
            </div>
            <div class="add-ftp-cont-body">
                <div style="margin-bottom: 5px;/*no*/">
                    <span class="add-ftp-des">{{$t('language.popup.addCloudPopup.addFtpDes')}}</span>
                </div>
                <div class="ftp-input-line">
                    <font class="cloud-cont-name">{{$t('language.popup.addCloudPopup.displayName')}}</font>
                    <span style="float:right;">
                        <cloud-select ref="cloudSelect" @changeOption='onChangeOption' :selectOption="selectOption" :placeholder="selectValue" style="min-width:180px;/*no*/"></cloud-select>
                    </span>
                    <input type="text" name="" class="ftp-cont-input" v-model="displayName" />
                </div>
                <div class="ftp-input-line">
                    <font class="cloud-cont-name">{{$t('language.popup.addCloudPopup.server')}}</font>
                    <input type="text" class="ftp-cont-right-one" v-model="port" />
                    <input type="text" class="ftp-cont-input" v-model="httpName" />
                    <div class="question-mark" id="questionMark">
                        <div class="icon-util question addftp-icon-position"> </div>
                        <div class="ftp-explanation">
                            <font v-html="$t('language.popup.addCloudPopup.explanation')"></font>
                        </div>
                    </div>

                </div>
                <div class="ftp-input-line">
                    <font class="cloud-cont-name">{{$t('language.popup.addCloudPopup.userName')}}</font>
                    <input type="text" class="ftp-cont-three" v-model="email" />
                </div>
                <div class="ftp-input-line">
                    <font class="cloud-cont-name">{{$t('language.popup.addCloudPopup.passWord')}}</font>
                    <input type="password" class="ftp-cont-three" v-model="password" />
                </div>
                <div class="advanced">
                    <div class="advanced-menu">
                        <font class="advanced-text" id="advancedText" @click="advancedDivShow()">{{$t('language.popup.addCloudPopup.advanced')}}
                            <div class="icon-util folding-panel slide" :class="{'folding-panel-up':advancedShow}" id="iconUtil"></div>
                        </font>
                    </div>
                </div>
            </div>
            <transition name="ftp-slide">
                <div class="add-ftp-buttom" v-show="advancedShow" v-cloak>
                    <div class="advanced-item">
                        <font class="advanced-item-name">{{$t('language.popup.addCloudPopup.commFTP')}}</font>
                        <span style="float:left;">
                            <cloud-select @changeOption='onChangeOptionTwo' :selectOption="commonFTP" :placeholder="selectFTPValue"></cloud-select>
                        </span>
                    </div>
                    <div class="advanced-item">
                        <font class="advanced-item-name">{{$t('language.popup.addCloudPopup.transMode')}}</font>
                        <span style="float:left;">
                            <cloud-select :selectOption="transferMode" @changeOption="changeTransferMode" :placeholder="selectModeValue"></cloud-select>
                        </span>
                    </div>
                    <div class="advanced-item">
                        <font class="advanced-item-name">{{$t('language.popup.addCloudPopup.encoding')}}</font>
                        <span style="float:left;">
                            <cloud-select :selectOption="enCoding" @changeOption='onChangeCharSet' :placeholder="selectCodValue"></cloud-select>
                        </span>
                    </div>
                    <div class="ftp-input-line">
                        <font class="cloud-cont-name">{{$t('language.popup.addCloudPopup.path')}}</font>
                        <input type="text" class="ftp-cont-three" v-model="path" :class="advancedShow&&!SftpShow?'path-input':''" />
                    </div>
                </div>
            </transition>
            <transition name="ftp-slide">
                <div class="add-ftp-text" v-if="SftpShow">
                    <div class="cloud-cont-name">{{$t('language.popup.addCloudPopup.privateKey')}}</div>
                    <textarea v-model="optional" rows="8"></textarea>
                </div>
            </transition>

            <button style="float:right;" @click.stop="addFtpSubmit()">
                <span v-show="!connect">{{$t('language.common.save')}}&nbsp;&nbsp;{{cloudName}} {{$t('language.common.account')}}</span>
                <span v-show="connect">{{$t('language.common.connecting')}}<span class="cloudDotting"></span></span>
            </button>

        </div>
    </div>
</div>
</template>

<script>
import cloudSelect from '@/components/common/select/cloud_select';
import addCloudUtils from '@/js/workspace/add_cloud_utils.js';
import commonstate from '@/js/constant.js';
import commonUtils from "@/js/workspace/common_util.js";
export default {
    data: function () {
        return {
            cloudInfo: {},
            ftpDialog: false,
            cloudName: '',
            cloudIcon: '',
            advancedShow: false, //控制高级选项是否显示
            foldingPanel: '',
            addFtp: '',
            selectValue: 'FTP',
            selectOption: [{
                name: 'FTP'
            }, {
                name: 'SFTP'
            }, {
                name: 'FTPS'
            }],
            commonFTP: [{
                name: 'Default'
            }, {
                name: 'Box'
            }, {
                name: 'ADrive'
            }, {
                name: 'Egnyte'
            }], //下拉框赋值
            selectFTPValue: 'Default', //用于存储FTP默认值
            transferMode: [{
                name: 'Passive'
            }, {
                name: 'active'
            }],
            selectModeValue: 'Passive',
            enCoding: [{
                name: 'Autodetect'
            }, {
                name: 'UTF-8'
            }, {
                name: 'ISO-8859-1'
            }, {
                name: 'GB2312'
            }, {
                name: 'GBK'
            }], //encoding下拉框赋值
            selectCodValue: 'Autodetect',
            explanShow: false, //用于定义弹框是否显示
            connect: false,
            displayName: 'FTP',
            httpName: 'ftp://',
            SftpShow: false,
            optional: '',
            email: '',
            password: '',
            path: '',
            port: '21',
            serverUrl: '',
            charSet: 'Autodetect',
            commonFtpName: 'Default',
            transferModeValue: 'Passive'
        }
    },
    mounted() {
        this.$refs.cloudSelect.widthValue = 180;
        this.$refs.ftpDiv.style.height = 460 + 'px';
    },
    components: {
        "cloud-select": cloudSelect
    },
    methods: {
        onChangeOption(newValue) {
            let that = this;
            switch (newValue) {
                case 'FTP':
                    this.displayName = newValue;
                    this.cloudName = newValue;
                    this.httpName = 'ftp://';
                    this.SftpShow = false;
                    if (this.advancedShow) {
                        this.$refs.ftpDiv.style.height = 630 + 'px';
                    } else {
                        this.$refs.ftpDiv.style.height = 440 + 'px';
                    }
                    break;
                case 'SFTP':
                    this.displayName = newValue;
                    this.cloudName = newValue;
                    this.httpName = 'sftp://';
                    this.SftpShow = true;
                    this.$nextTick(function () {
                        if (that.advancedShow) {
                            that.$refs.ftpDiv.style.height = 785 + 'px';
                        } else {
                            that.$refs.ftpDiv.style.height = 630 + 'px';
                        }
                    });
                    break;
                case 'FTPS':
                    this.displayName = newValue;
                    this.cloudName = newValue;
                    this.httpName = 'ftps://';
                    this.SftpShow = false;
                    if (this.advancedShow) {
                        this.$refs.ftpDiv.style.height = 630 + 'px';
                    } else {
                        this.$refs.ftpDiv.style.height = 440 + 'px';
                    }
                    break;
            }
        },
        onChangeOptionTwo(newValue) {
            this.commonFtpName = newValue;
            this.$refs.cloudSelect.currentValue = 'FTP';
            switch (newValue) {
                case 'Default':
                    this.displayName = 'FTP';
                    this.cloudName = 'FTP';
                    this.httpName = 'ftp://';
                    this.SftpShow = false;
                    this.$refs.ftpDiv.style.height = 630 + 'px';

                    break;
                case 'Box':
                    this.displayName = 'FTP-Box';
                    this.cloudName = 'FTP';
                    this.httpName = 'ftp://ftp.box.com';
                    this.SftpShow = false;
                    this.$refs.ftpDiv.style.height = 630 + 'px';
                    break;
                case 'ADrive':
                    this.displayName = 'FTP-ADrive';
                    this.cloudName = 'FTP';
                    this.httpName = 'ftp://ftp.adrive.com';
                    this.SftpShow = false;
                    this.$refs.ftpDiv.style.height = 630 + 'px';
                    break;
                case 'Egnyte':
                    this.displayName = 'FTPS-Egnyte';
                    this.cloudName = 'FTPS';
                    this.httpName = 'ftps://ftp-domain.egnyte.com';
                    this.SftpShow = false;
                    this.$refs.ftpDiv.style.height = 630 + 'px';
                    break;
            }
        },
        onChangeCharSet(newValue) {
            switch (newValue) {
                case 'Autodetect':
                    this.charSet = newValue
                    break;
                case 'UTF-8':
                    this.charSet = newValue
                    break;
                case 'ISO-8859-1':
                    this.charSet = newValue
                    break;
                case 'GB2312':
                    this.charSet = newValue
                    break;
                case 'GBK':
                    this.charSet = newValue
                    break;
            }
        },
        changeTransferMode(newValue) {
            this.transferModeValue = newValue;
        },
        letExplanShow() {
            this.explanShow = true;
        },//提交编辑FTP
        addFtpSubmit() {
            this.connect = true;
            let that = this;
            if (!this.displayName) {//如果任务名称为空
                that.$toast({
                    text: this.$t('language.exception.nameEmpty'),
                    type: 'fail',
                    idValue: "rightContBan"
                });
                this.connect = false;
                return false;
            }
            if (commonstate.patternDriveName.test(this.displayName)) {//如果任务名称含有特殊字符
                that.$toast({
                    text: that.$t('language.home.driveNameNotContain'),
                    type: 'fail',
                    idValue: "rightContBan"
                });
                this.connect = false;
                return false;
            }
            if (this.displayName.length > 200) {//如果云盘名称长度大于200
                that.$toast({
                    text: 'FTP name cannot exceed 200 characters',
                    type: 'fail',
                    idValue: "rightContBan"
                });
                this.connect = false;
                return false;
            }
            let redirectUrl = commonstate.addCloudRedirectUrl;
            let user = commonUtils.getUser();
            let content = this.optional.replace('\n', '<br/>');
            let  patternStpName = new RegExp("(:\\d+)?(?=((?<!\/)\/[^\/])|(\/?$))");
            let httpName=this.httpName.replace(patternStpName,':'+this.port);
            this.serverUrl = httpName  + '?' + this.charSet + '!' + this.transferModeValue;
            let rewriteData = new addCloudUtils.reWriteCloudData(user.id, this.cloudInfo.id, this.displayName, this.email, this.password, null, this.serverUrl, this.optional, null, 'FTP', null, this.path, redirectUrl);
            this.Utils.doDrivesRequest("re-write", rewriteData).then(res => {
                if (res.status == 200) {
                    that.connect = false;
                    //如果父组件可以控制是否显示，则同样关闭（1还原弹窗）
                    if(that.$parent.isShow){
                        that.$parent.isShow = false;
                        //把编辑过的云盘数据存入云盘缓存进行封装
                       addCloudUtils.editCloudByRestore(res.drive,that);
                    }else{
                        //把编辑过的云盘数据存入云盘缓存进行封装
                       addCloudUtils.editStoreDrive(res.drive,that);
                    }
                    that.ftpDialog = false;
                    if(that.$route.name == 'cloudExploer'||that.$route.name == 'emailExploer'){
                     const vm = window.vm.$children[0].$refs.routerView.$refs.routView;
                     vm.noLoadInitialFileData(function(res){});
                    }
                } else {
                    that.connect = false;
                    that.$toast({
                        text: this.$t('language.exception.' + res.reason),
                        type: 'fail',
                        idValue: "rightContBan"
                    });
                }
            });
        },
        advancedDivShow() {
            this.advancedShow = !this.advancedShow;
            if (this.advancedShow && this.SftpShow) {
                this.$refs.ftpDiv.style.height = 785 + 'px';
            } else if (this.SftpShow || this.advancedShow) {
                this.$refs.ftpDiv.style.height = 630 + 'px';
            } else {
                this.$refs.ftpDiv.style.height = 440 + 'px';
            }
        }
    }
}
</script>

<style scoped>
/*添加ftp弹框*/
#editFtp {
    width: 680px;
    /*no*/
    height: 440px;
    /*no*/
}

.add-ftp-cont {
    width: 620px;
    /*no*/
    padding: 0 40px 0px 20px;
    /*no*/
}

.add-ftp-cont-body {
    width: 100%;
    padding-top: 20px;
    /*no*/
    height: 250px;
    /*no*/
}

.add-ftp-buttom {
    width: 100%;
    height: 180px;
    /*no*/
}

.add-ftp-text {
    width: 100%;
    height: 180px;
    /*no*/
}

.path-input {
    margin-bottom: 20px;
    /*no*/
}

.add-ftp-text textarea {
    width: 100%;
    height: 120px;
    /*no*/
    box-sizing: border-box;
    padding: 15px 10px 0px 15px;
    /*no*/
    border: 1px solid #d4edfa;
    /*no*/
    font-size: 14px;
    /*no*/
    /*no*/
    font-family: Arial, "Microsoft YaHei", 微软雅黑;
    resize: none;
    color: #6f7886;
    margin-top: 5px;
    /*no*/
    white-space: pre-wrap !important;
}

.add-ftp-text textarea::-webkit-input-placeholder {
    color: #ccc;
}

.add-ftp-text textarea:focus {
    border: 1px solid #8a96e3;
    /*no*/
    outline: none;
}

.add-ftp-des {
    font-size: 14px;
    /*no*/
    color: rgba(0, 0, 0, 0.55);
}

.ftp-cont-three {
    width: 480px;
    /*no*/
    float: right;
    color: rgba(0, 0, 0, 0.6);
    ;
}

.ftp-input-line {
    float: right;
    width: 100%;
}

.advanced-item-name {
    font-size: 14px;
    /*no*/
    margin-right: 30px;
    /*no*/
    float: left;
    width: 100px;
    /*no*/
}

.drive-add-ftps {
    width: 100%;
    height: 47.5%;
    text-align: center;
    margin-top: 2%;
    border-bottom: 1px solid #FFF;
    /*no*/
}

.select-ftp-value {
    width: 178px;
    /*no*/
    height: 136px;
    /*no*/
    position: absolute;
    z-index: 1;
    font-size: 14px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    border: 1px solid #8A96E3;
    /*no*/
    border-top: none;
    background: #FFF;
    left: 130px;
    /*no*/
    top: 44px;
    /*no*/
}

.ftp-slide-enter-active {
    transition: all 0.5s ease;
    height: 100px;
    /*no*/
    overflow: hidden;
}

.ftp-slide-leave-active {
    transition: all 0s ease;
    height: 0px;
    /*no*/
    overflow: hidden;
}

.ftp-slide-enter,
.ftp-slide-leave {
    height: 0;
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/add_cloud_popups/edit_ftp_popup.vue